import * as Yup from "yup";

export const IncidentReasonSchema = Yup.object().shape({
  reason: Yup.string()
    .trim("La razón no puede contener solo espacios en blanco")
    .min(5, "La razón debe tener al menos 5 caracteres")
    .required("La razón es requerida"),
});

export const IncidentReasonCheckoutSchema = Yup.object().shape({
  reason: Yup.string()
    .trim("La razón no puede contener solo espacios en blanco")
    .min(5, "La razón debe tener al menos 5 caracteres")
    .required("La razón es requerida"),
  checkout: Yup.number()
    .required("Marca la hora de salida")
    .notOneOf([-1], "Marca la hora de salida"),
});

export const IncidentReason = {
  reason: "",
  type: "",
  checkout: -1,
};
